
namespace RioERP.Reports {
    export class FranchiseeOutstandingColumns {
        static columnsKey = 'Reports.FranchiseeOutstanding';
    }
}